import React from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import GoogleTrustIndex from "components/GoogleTrustIndex";

function InformationHome({ hideLocationBlock }) {
    return (
        <MKBox component="section" pt={12} pb={0}>
            <Container>
                <Grid
                    container
                    item
                    xs={12}
                    lg={6}
                    justifyContent="center"
                    sx={{ mx: "auto", textAlign: "center" }}
                >
                    <MKTypography variant="h1" component="h2" color="dark" mb={2}>
                        Doral Cleaning - Servicii profesionale de curatenie
                    </MKTypography>
                    <MKTypography variant="h2">
                        Avem o experiență solidă în colaborarea cu clienți din diverse domenii.
                        &nbsp;
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        Suntem o firmă de curățenie din Sectorul 4 al Bucureștiului, cu sediul pe
                        Calea Șerban Vodă 82, și lucrăm în toate sectoarele capitalei și în Ilfov.
                        Am încheiat cu succes mii de proiecte de mari și mici dimensiuni, alături de
                        companii private, clădiri de birouri, instituții locale, publice și private,
                        spații comerciale, spații industriale, ansambluri rezidențiale etc.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2} fontWeight="bold">
                        <i className="fas fa-map-marker-alt" style={{ marginRight: "8px" }} />
                        <MKTypography
                            component="a"
                            href="https://maps.app.goo.gl/ZvLDzHRXk4KXUUwS6"
                            target="_blank"
                            rel="noreferrer"
                            sx={{ color: "inherit" }}
                        >
                            <u>
                                Calea Șerban Vodă 82, Sector 4, 040213 (Între Unirii și Tineretului)
                            </u>
                        </MKTypography>
                        <MKTypography variant="body2" color="text" display="block" mt={1}>
                            <strong>Program:</strong> Luni - Vineri: 08:00 - 17:00 | Sâmbătă: 09:00
                            - 14:30
                        </MKTypography>
                    </MKTypography>
                </Grid>

                <MKBox mt={4}>
                    <GoogleTrustIndex />
                </MKBox>

                {!hideLocationBlock && (
                    <MKBox mt={8} textAlign="left">
                        <MKTypography variant="body1" color="text" mb={3}>
                            Ești în căutarea unei <strong>firme de curățenie</strong> de încredere,
                            chiar în inima orașului? Echipa Doral Cleaning îți stă la dispoziție la
                            sediul nostru de pe Calea Șerban Vodă nr. 82, situat strategic între
                            zonele <strong>Unirii și Tineretului</strong>.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Suntem partenerul tău ideal pentru servicii complete, acoperind nevoi
                            variate, de la întreținerea spațiilor industriale mari — precum{" "}
                            <strong>fabrici, depozite și hale</strong> — până la intervenții
                            specializate de curățenie după <strong>renovare</strong>. Ca{" "}
                            <strong>firmă de curățenie</strong> dedicată calității, transformăm
                            orice spațiu într-un mediu perfect igienizat și primitor.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Ne găsești foarte ușor, fiind situați în apropierea unor puncte de reper
                            importante din București:
                        </MKTypography>
                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Parcul Carol I</strong> și{" "}
                                <strong>Parcul Tineretului</strong>;
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Centrul Vechi</strong> și cunoscuta{" "}
                                <strong>Shaormerie Dristor</strong>;
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                Acces facil prin stațiile de <strong>Metrou Tineretului</strong> și{" "}
                                <strong>Metrou Unirii</strong>.
                            </MKTypography>
                        </MKBox>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Alege profesionalismul Doral Cleaning pentru a-ți menține afacerea sau
                            locuința la cele mai înalte standarde de curățenie.
                        </MKTypography>
                        <MKTypography variant="h5" color="dark" mb={2}>
                            Contactează-ne:
                        </MKTypography>
                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Telefon:</strong> 0730 407 322
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Adresă:</strong> Calea Șerban Vodă 82, Sector 4, 040213
                                București
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Program:</strong> Luni - Vineri: 08:00 - 17:00 | Sâmbătă:
                                09:00 - 14:30
                            </MKTypography>
                        </MKBox>
                    </MKBox>
                )}
            </Container>
        </MKBox>
    );
}

InformationHome.propTypes = {
    hideLocationBlock: PropTypes.bool,
};

InformationHome.defaultProps = {
    hideLocationBlock: false,
};

export default InformationHome;
